import { reduxForm } from 'redux-form'
import at from 'lodash/at'
import get from 'lodash/get'

import { goBack } from 'react-router-redux'
import { loadAreaTypesByLocation } from '../../actions/area-types'
import { setAreaTypeFilterForLocation } from '../../actions/work-tracker-filters'

import WorkTrackerFilterModal from '../../components/work-trackers/work-tracker-filter-modal'

const fields = [
  'resourceId'
]

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId
  let ids = []
  let resources = []

  if (state.pagination.areaTypesByLocation[id]) {
    ids = state.pagination.areaTypesByLocation[id].ids
    resources = at(state.areaTypes, ids || [])
  }

  return {
    resourceName: 'area type',
    modalTitle: 'Choose an Area Type',
    hasNextPage: get(state, `pagination.areaTypesByLocation.${id}.nextPageUrl`),
    initialValues: {
      resourceId: get(state, `workTrackerFilters.${id}.areaTypeId`)
    },
    resources
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId

  dispatch(loadAreaTypesByLocation(id))

  return {
    handleClose () {
      dispatch(goBack())
    },

    onSubmit (data) {
      dispatch(setAreaTypeFilterForLocation(id, data.resourceId))
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'filterContract'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkTrackerFilterModal)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-area-type-filter-container.js